import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

class FeedRegister extends Component {
  render() {
    return (
      <div className="feed-register-page pulled-up">
        <div className="page-body">
          <p>
            {strings.feedRegister.infoLine1}{' '}
            <a
              href={require('common/data/FIX Registration Form v0.1.pdf')}
              download={strings.feedRegister.pdfFormFileName}
            >
              here.
            </a>
          </p>
          <p>
            {strings.feedRegister.infoLine2}{' '}
            <a href={`mailto:${strings.feedRegister.emailToAddress}`} target="_top">
              {strings.feedRegister.emailToAddress}
            </a>{' '}
            .
          </p>
        </div>
      </div>
    );
  }
}

export default FeedRegister;



// WEBPACK FOOTER //
// ./src/containers/Register/FeedRegister.jsx